import './Checkboxes.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
const Checkboxes = _ref => {
  let {
    checkboxes,
    changeEvent,
    fieldError
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  function handleChange(event) {
    changeEvent(event.target.name, event.target.checked);
  }
  function keyPressHandler(e) {
    const target = e.target;
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      e.preventDefault();
      changeEvent(target.name, !target.checked);
    }
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, checkboxes.map(_ref2 => {
    let {
      name,
      label,
      value,
      id,
      isRequired = false,
      childrenHTML
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: "form-check",
      key: label
    }, /*#__PURE__*/React.createElement("input", {
      className: "form-check-input checkbox lr__cb",
      type: "checkbox",
      checked: value,
      name: name,
      onChange: handleChange,
      id: id,
      onKeyPress: keyPressHandler,
      title: label,
      "aria-label": label
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: id
    }, /*#__PURE__*/React.isValidElement(childrenHTML) ? childrenHTML : label, " ", isRequired ? '*' : ''));
  }), fieldError && fieldError.length ? fieldError.split('[|]').map((error, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "lr__error"
  }, error)) : null));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "ch0w7pf";
const ltrStyles = "l86hcp6";
const rtlStyles = "r18d3ad8";
export default Checkboxes;